import { render, staticRenderFns } from "./customDelCheck.vue?vue&type=template&id=1fd2b772&scoped=true&"
import script from "./customDelCheck.vue?vue&type=script&lang=js&"
export * from "./customDelCheck.vue?vue&type=script&lang=js&"
import style0 from "./customDelCheck.vue?vue&type=style&index=0&id=1fd2b772&lang=scss&scoped=true&"
import style1 from "./customDelCheck.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2b772",
  null
  
)

export default component.exports